/*
  ST 2026-09-29 (Wrike 4574978729): open/close animation of the Refurbished info box.
  The variant change re-renders the whole variant picker (Concept ProductInfo), so the new
  <st-refurb-info> arrives already open or closed. The change on the condition input is
  remembered here; the new element animates from the old state when it connects
  (height + opacity, 180 ms open / 150 ms close, none under prefers-reduced-motion).
  Markup: snippets/st-refurb-condition.liquid. Rollback: variant_picker setting off.
*/
(function () {
  if (window.customElements.get('st-refurb-info')) return;

  var pending = null; // { open: boolean, at: timestamp }
  var PENDING_MS = 4000;

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || !input.classList || !input.classList.contains('st-condition__input')) return;
    pending = { open: input.hasAttribute('data-refurb-condition') && !input.disabled, at: Date.now() };
  }, true);

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  class StRefurbInfo extends HTMLElement {
    connectedCallback() {
      var state = pending;
      if (!state || Date.now() - state.at > PENDING_MS) return;
      if (state.open === this.hidden) return; // server state does not match the click (e.g. sold out)
      pending = null;
      if (reducedMotion() || typeof this.animate !== 'function') return;

      if (state.open) {
        var height = this.scrollHeight;
        this.animate(
          [{ height: '0px', opacity: 0 }, { height: height + 'px', opacity: 1 }],
          { duration: 180, easing: 'ease-out' }
        );
      } else {
        // The new element is already hidden: show it for the closing animation only.
        this.hidden = false;
        var from = this.scrollHeight;
        var self = this;
        var closing = this.animate(
          [{ height: from + 'px', opacity: 1 }, { height: '0px', opacity: 0 }],
          { duration: 150, easing: 'ease-in' }
        );
        closing.onfinish = closing.oncancel = function () {
          self.hidden = true;
        };
      }
    }
  }

  window.customElements.define('st-refurb-info', StRefurbInfo);

  // Wrike 4574978729 (Ali, variant D): below 750 px the box is a banner; a tap on it opens or closes the box
  // (.is-open, CSS in st-refurb-condition.css). Delegated on document, because every variant change replaces
  // <st-refurb-info>; the new element arrives collapsed.
  document.addEventListener('click', function (event) {
    var row = event.target && event.target.closest ? event.target.closest('.st-refurb-banner__row') : null;
    if (!row) return;
    var info = row.closest('st-refurb-info');
    if (!info) return;
    var open = !info.classList.contains('is-open');
    info.classList.toggle('is-open', open);
    row.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  // Announcement bar: the "2 Jahre Garantie" slide shows "12 Monate Garantie" while a Refurbished
  // variant is selected (body.st-refurb-active, CSS in st-refurb-condition.css, markup in
  // snippets/announcements-carousel.liquid). The initial state is set inline by main-product.
  var tries = 0;
  function bindVariant() {
    if (!(window.theme && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS)) {
      if (++tries > 25) return;
      return setTimeout(bindVariant, 200);
    }
    theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.variantChange, function (payload) {
      // publish() has no try/catch: a throw here would break the other handlers.
      try {
        var variant = payload && payload.data && payload.data.variant;
        if (!variant) return;
        document.body.classList.toggle('st-refurb-active', /refurbished/i.test(variant.title || ''));
        skipFinanceSlides();
      } catch (e) {
        /* ignore */
      }
    });
  }
  bindVariant();

  // Round 3: no "0% Finanzierung" announcement while Refurbished is selected. The carousel (Flickity, fade)
  // jumps over .st-finance-slide in the direction it was moving (markup: snippets/announcements-carousel.liquid).
  function isRefurb() {
    return document.body.classList.contains('st-refurb-active');
  }
  function skipFrom(bar, back) {
    var s = bar.slider;
    if (!s || !s.cells || s.cells.length < 2) return;
    var n = s.cells.length;
    var i = s.selectedIndex;
    for (var k = 0; k < n; k++) {
      var cell = s.cells[i] && s.cells[i].element;
      if (!cell || !cell.classList.contains('st-finance-slide')) break;
      i = back ? (i - 1 + n) % n : (i + 1) % n;
    }
    if (i !== s.selectedIndex) s.select(i, true, true);
  }
  function skipFinanceSlides() {
    if (!isRefurb()) return;
    document.querySelectorAll('announcement-bar').forEach(function (bar) {
      skipFrom(bar, false);
    });
  }
  document.addEventListener('slider:change', function (event) {
    var bar = event.target;
    if (!bar || bar.tagName !== 'ANNOUNCEMENT-BAR' || !bar.slider) return;
    var n = bar.slider.cells.length;
    var prev = bar.__stPrevIndex;
    var cur = event.detail ? event.detail.currentPage : bar.slider.selectedIndex;
    bar.__stPrevIndex = cur;
    if (!isRefurb()) return;
    skipFrom(bar, typeof prev === 'number' && cur === (prev - 1 + n) % n);
  });
})();
